import { api } from '@/modules/apiv2';

export default {
  state: {
    account: { ContactInformation: {} },
    accounts: [],
    canMakePatrol: false,
  },

  getters: {
    account(state) {
      return state.account;
    },

    accounts(state) {
      return state.accounts;
    },

    canMakePatrol(state) {
      return state.canMakePatrol;
    },
  },

  mutations: {
    setAccount(state, account) {
      state.account = account;
    },

    setAccounts(state, accounts) {
      state.accounts = accounts;
      for (let account of state.accounts) {
        if (account.AccountType === 'Dispatcher') {
          state.canMakePatrol = true;
          return;
        }
      }
      state.canMakePatrol = false;
    },
  },

  actions: {
    getAccount({ commit, getters }, accountId) {
      const endpoint = getters.accountsEndpoint;

      return api
        .get(`${endpoint}/${accountId}`)
        .then((data) => {
          commit('setAccount', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getAccounts({ commit, getters }) {
      const endpoint = getters.accountsEndpoint;

      return api
        .get(endpoint)
        .then((data) => {
          commit('setAccounts', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    createAccount({ commit, getters }, data) {
      const endpoint = getters.accountsEndpoint;

      return api
        .post(endpoint, data)
        .then((response) => {
          commit('setAccount', response);
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },

    updateAccount({ commit, getters }, data) {
      const endpoint = getters.accountsEndpoint;

      return api
        .put(`${endpoint}/${data.id}`, data)
        .then((data) => {
          commit('setAccount', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    deleteAccount({ commit, getters }, id) {
      const endpoint = getters.accountsEndpoint;

      return api
        .delete(`${endpoint}/${id}`)
        .then(() => {
          commit('setAccount', null);
          return;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
